module.exports = __webpack_public_path__ + "img/p2.7a369ffe.png";